import {Colors} from '@eitje/assets'

export const HOVER_AREA = 20

const MARKER_SIZE = 3
const MARKER_CENTER = HOVER_AREA / 2
const SHADOW_CENTER = MARKER_CENTER + 0.8

const STATUS_ICON_MAPPING = {
	active: {fill: 'green'},
	inactive: {fill: 'red'},
	demo: {fill: 'transparent', stroke: 'green'},
	expired: {fill: 'transparent', stroke: 'red'},
	eitje: {fill: 'blue'},
	mixed: {fill: 'yellow'},
}

export const ICONS = {}
_.forEach(STATUS_ICON_MAPPING, ({fill, stroke}, status) => {
	fill = Colors[fill] || fill
	stroke = Colors[stroke]

	//leads and non leads markers use a different shadow (ring vs dot)
	const shadowFill = fill === 'transparent' ? 'none' : 'rgba(0,0,0,0.25)'
	const shadowStroke = fill === 'transparent' ? 'rgba(0,0,0,0.25)' : 'none'
	const shadowStrokeWidth = fill === 'transparent' ? 2 : 0

	const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${HOVER_AREA}" height="${HOVER_AREA}">
      <circle cx="${SHADOW_CENTER}" cy="${SHADOW_CENTER}" r="${MARKER_SIZE}" fill="${shadowFill}" stroke="${shadowStroke}" stroke-width="${shadowStrokeWidth}"/>
      <circle cx="${MARKER_CENTER}" cy="${MARKER_CENTER}" r="${MARKER_SIZE}" fill="${fill}" ${
				stroke ? `stroke="${stroke}" stroke-width="1"` : ''
			}/>
    </svg>
  `

	ICONS[status] = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg)
})
